import React from 'react';
import './FooterCaption.less';

export const FooterCaption = ({text}) => {
	return <span className="footer-caption">{text}</span>
}
